const paymentLabels = [
    {
        title: 'Factura',
        type: 'columns',
        fields: [
            {
                label: '[FACTURA]',
                description: 'invoice_number',
                visible: true
            },
            {
                label: '[REFNUMBER]',
                description: 'reference_number',
                visible: true
            },
            {
                label: '[FECHACREACION]',
                description: 'creation_date',
                visible: true
            }
        ]
    },
    {
        title: 'Empresa y Agencia',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            { label: '[AGENTE]', description: 'agent_name', visible: true },
            {
                label: '[NOMBREAGENCIA]',
                description: 'agency_name',
                visible: true
            }
        ]
    },
    {
        title: 'Pago',
        type: 'columns',
        fields: [
            { label: '[TIPOPAGO]', description: 'payment_type', visible: true },
            { label: '[MONTO]', description: 'amount', visible: true },
            { label: '[CURRENCY]', description: 'currency', visible: true }
        ]
    },
    {
        title: 'Otros',
        type: 'columns',
        fields: [
            { label: '[NOTA]', description: 'note', visible: true },
            {
                label: '[VERIFICACION]',
                description: 'verification',
                visible: true
            }
        ]
    }
];

export default paymentLabels;
